


import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { randomId } from '@mui/x-data-grid-generator';
import {
  Box,
  Button,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import { DefaultCard } from '../../assets/styled-components/card';
import CustomTextField from '../commoncomponents/CustomTextField';
import { getAuthToken } from "../../utility/tokenUtility";
import { MasterGraph, FemsGraph } from '../../utility/apiURLS';
import CustomDialog from '../commoncomponents/CustomDialog';
import CustomAgGrid from '../commoncomponents/CustomAgGrid';
import { v4 as uuidv4 } from 'uuid';
import SectionTitle from '../commoncomponents/SectionTitle';
import AddRoundedIcon from "@mui/icons-material/AddRounded";
const initialRow = {
  id: 1,
  file: null,
  documenttitle: '',
  documenttype: '',
  filesize: '',
};


export default function AttachmentFemsTechDrawing({ hospitalcode, isEdit, hospitalid, isView, isEditMode, femsTechId, editId, viewId }) {
  const [rows, setRows] = useState(isView ? [] : [initialRow]);
  const [getByIdFiles, setGetByIdFiles] = useState([]);
  //  const [rows, setRows] = useState([initialRow]);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const navigate = useNavigate();
  const hospitalDetailsId = useSelector((state) => state.form.mashospitaldetailsId);
  const token = getAuthToken("id_token");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const facilityId = hospitalid;
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
  const [gridApi, setGridApi] = useState(null);
  const [registeredFiles, setRegisteredFiles] = useState([]);
  const [storeFileName, setStoreFileName] = useState([]);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [isSaveSuccessful, setIsSaveSuccessful] = useState(false);
  const [showSaveButton, setShowSaveButton] = useState(true);
  
  //const femtechnicaldrawingId = isEdit ? editId : femsTechId;
  const femtechnicaldrawingId = isEdit ? editId : (isView ? viewId : femsTechId);

  const fetchFiles = async () => {
    try {
      const response = await axios.get(`${FemsGraph}/api/graph/GetFemtechdrawAttachmentList/${femtechnicaldrawingId}`, config);
   
      const fetchedFiles = response.data||[]; 
      setGetByIdFiles(fetchedFiles);
      setRows(isView ? fetchedFiles : (fetchedFiles.length > 0 ? fetchedFiles : [initialRow]));

      // setRows(fetchedFiles.length > 0 ? fetchedFiles : [initialRow]); // Update rows state, defaulting to initialRow if no files fetched
    } catch (error) {
      console.error('Error fetching files:', error);
    }
  };
  useEffect(() => {
    fetchFiles();
  }, []);

  const handleDeleteClick = (id) => () => {
    // Check if the id is a string and not an empty string
    if (typeof id === 'string' && id.trim()) {
        // Set the selected ID for the row to be deleted
        setSelectedId(id);
        // Open the delete confirmation dialog
        setDeleteDialogOpen(true);
    } else {
        // If the id is empty or not a string, delete the row immediately
        const updatedRows = rows.filter((row) => row.id !== id);
        setRows(updatedRows);

        // Remove the corresponding file from selectedFiles
        const updatedSelectedFiles = selectedFiles.filter(file => file.id !== id);
        setSelectedFiles(updatedSelectedFiles);
    }
};
  const handleDeleteConfirm = async () => {
    // Find the row with the selected ID
    const selectedRow = rows.find(row => row.id === selectedId);

    // If the row exists
    if (selectedRow) {
      if (selectedRow.id) {
        try {
          // If the row has been saved to the database, delete it using the API
          const response = await axios.delete(`${FemsGraph}/api/femtechnicaldrawingattachments/${selectedId}`, config);
          if (response.status >= 200 && response.status <= 204) {
            // Remove the row from the state
            const updatedRows = rows.filter((row) => row.id !== selectedId);
            setRows(updatedRows);

            // Remove the corresponding file from selectedFiles
            const updatedSelectedFiles = selectedFiles.filter(file => file.id !== selectedId);
            setSelectedFiles(updatedSelectedFiles);

            setSuccessMessage('Record deleted successfully.');
            setSuccessDialogOpen(true);
          } else {
            setError(true);
            setErrorMessage('Error deleting record. Please try again.');
          }
        } catch (error) {
          console.error('Error deleting attachment:', error);
          setError(true);
          setErrorMessage('Error deleting attachment. Please try again.');
        }
      } else {
        // If the row hasn't been saved to the database, just remove it from the state
        const updatedRows = rows.filter((row) => row.id !== selectedId);
        setRows(updatedRows);

        // Remove the corresponding file from selectedFiles
        const updatedSelectedFiles = selectedFiles.filter(file => file.id !== selectedId);
        setSelectedFiles(updatedSelectedFiles);

        setSuccessMessage('Record deleted successfully.');
        setSuccessDialogOpen(true);
      }
    }

    // Close the delete dialog
    setDeleteDialogOpen(false);
  };

  const handleDeleteDialogClose = () => {
    setDeleteDialogOpen(false);
  };

  const handleSuccessDialogClose = () => {
    setSuccessDialogOpen(false);
  };

  const handleAddRow = () => {
    //  const id = randomId();
    const id =
	rows.length > 0
	? Math.max(...rows.map((row) => (isNaN(row.id) ? 0 : Number(row.id)))) + 1
: 1;
    const newRow = {
      id: id,
      file: null,
      documenttitle: '',
      documenttype: '',
      filesize: '',
    };
    setRows([...rows, newRow]);
   // setRows((oldRows) => [...oldRows, newRow]);
  };

  const handleFileChange = (event, id) => {
    const file = event.target.files[0];
    if (!file) return;
    const fileName = file.name;
    const fileExtension = fileName.split('.').pop().toLowerCase();
    if (file.size > 20 > 1024 > 1024) {
      setError(true);
      setErrorMessage('Error: File size exceeds 20 MB. Please select smaller files.');
      return;
    };

    const allowedFileExtensions = ['doc', 'jpeg', 'jpg', 'png', 'xlsx', 'csv', 'pdf', 'docx'];
    if (!allowedFileExtensions.includes(fileExtension)) {
      setError(true);
      setErrorMessage('Error: Only DOC, JPEG, JPG, PNG, XLSX, CSV, and PDF files are allowed.');
      return;
    };

    const fileNameWithoutExtension = fileName.replace(new RegExp(`.${fileExtension}$`), '');

    let updatedSelectedFiles = [...selectedFiles];
    const fileIndex = updatedSelectedFiles.findIndex((file) => file.id === id);
    if (fileIndex > -1) {
      updatedSelectedFiles[fileIndex] = { id, file };
    } else {
      updatedSelectedFiles.push({ id, file });
    };
    setSelectedFiles(updatedSelectedFiles);

    const updatedRows = rows.map((row) => {
      if (row.id === id) {
        let fileSize;
        if (file.size >= 1024 * 1024) {
          fileSize = (file.size / (1024 * 1024)).toFixed(2) + ' MB';
        } else {
          fileSize = (file.size / 1024).toFixed(2) + ' KB';
        };

        return {
          ...row,
          file,
          documenttitle: fileName,
          documenttype: fileExtension,
          filesize: fileSize,
        };
      };
      return row;
    });

    setRows(updatedRows);
    setHasUnsavedChanges(true);
  };

  const handleDownload = async (file) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${getAuthToken('id_token')}`
        }
      }
      const isFileStored = getByIdFiles?.find((item) => item?.id === file?.id)
      if ((file && file?.filename || storeFileName?.length > 0) && isFileStored) { //this will handle edit time or store time download
        const fileName = file?.filename;
        const response = await axios.get(`${MasterGraph}/api/FileUpload/DownloadFile/${fileName}`, {
          ...config,
          responseType: 'blob'
        });
        if (response) {
          const url = URL.createObjectURL(response.data);
          const a = document.createElement('a');
          a.href = url;
          a.download = file?.documenttitle;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        }
      } else { //this will handle initial time download
        if (file) {
          // convert the file to blob
          const fileToDownload = file?.file;
          if (fileToDownload) {
            const blob = new Blob([fileToDownload], { type: fileToDownload.type });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileToDownload.name || 'downloaded_file';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
          } else {
            console.log('Invalid file object:', file);
          }
        }
      }
    } catch (error) {
      console.log('Error downloading file:', error);
    }
  };




  const handleDownloadClick = (event, file) => {
    event.preventDefault();
    handleDownload(file);
  };
  function uuidv4(extension) {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    }) + '.' + extension;
  };

    const uploadFiles = async (formData) => {
    try {
        let storeFileNameArray = [];
        let storeregsitredFilesResponse = [];
        let storefileUploadResponse = [];
        for (let i = 0; i < selectedFiles?.length; i++) {
            const formData = new FormData();
            const extension = selectedFiles[i]?.file?.name.split('.').pop();
            const fileName = uuidv4(extension); // generate a unique id
            formData.append('fileObj', selectedFiles[i]?.file, fileName); // append file with unique id as filename
            storeFileNameArray.push({ id: fileName, filename: `${selectedFiles[i]?.file?.name}`, selectedFileId: selectedFiles[i]?.id });

            try {
                const fileUploadResponse = await axios.post(`${MasterGraph}/api/fileupload`, formData, config);
                storeregsitredFilesResponse.push(fileUploadResponse.data);
                storefileUploadResponse.push(fileUploadResponse.data);
            } catch (error) {
                console.log('Error uploading file:', error.response ? error.response.data : error.message);
            }
        }
        setStoreFileName(storeFileNameArray);
        setRegisteredFiles(storeregsitredFilesResponse);
        return { storefileUploadResponse, storeFileNameArray };
    } catch (error) {
        console.error('Save error:', error);
        throw error;
    }
};

  const saveFilesToAttachment = async (payload) => {
    try {
      const response = await axios.post(`${FemsGraph}/api/femtechnicaldrawingattachments`, payload, config);
      if (response.status >= 201 && response.status <= 204) {
        setOpenDialog(true);
        setIsSaveSuccessful(true);
        
      }
      return response.data;
    } catch (error) {
      console.error('Save error:', error);
      throw error;
    }
  };

  // const handleSaveClick = async () => {
  //   try {
  //     // Filter selectedFiles to ensure we only upload files still linked to existing rows
  //     const filteredSelectedFiles = selectedFiles.filter(file => rows.some(row => row.id === file.id));

  //     // Proceed only if there are files to upload
  //     if (filteredSelectedFiles.length > 0) {
  //       const { storefileUploadResponse, storeFileNameArray } = await uploadFiles(filteredSelectedFiles);

  //       if (storefileUploadResponse?.length > 0) {
  //         let storefileUploadResponseFinal = [];

  //         for (let i = 0; i < storefileUploadResponse.length; i++) {
  //           const file = storefileUploadResponse[i];
  //           console.log('filesiz', file.fileSize)
  //           const documentTitle = storeFileNameArray.find((item) => item.id === file.fileName)?.filename;
  //           const documenttype = documentTitle.split('.').pop().toLowerCase();
  //           console.log('documenttype', documenttype)

  //           if (documentTitle) {
  //             const payload = {
  //               filename: file.fileName,
  //               filesize: file.fileSize,
  //               filepath: "D:/IFAC-X/UploadFolder",
  //               documenttitle: documentTitle,
  //               documenttype: documenttype,
  //               femtechnicaldrawingId: femtechnicaldrawingId,
  //             };

  //             try {
  //               const response = await saveFilesToAttachment(payload);
  //               setHasUnsavedChanges(false);
  //               if (response) {
  //                 storefileUploadResponseFinal.push(response);
  //                 fetchFiles();
  //               } else {
  //                 console.log("Error saving file:", file.fileName);
  //               }
  //             } catch (error) {
  //               console.log('Error saving file:', error);
  //             }
  //           } else {
  //             console.log("Document Title not found for file:", file.fileName);
  //           }
  //         }

  //         if (storefileUploadResponseFinal.length === storefileUploadResponse.length) {
  //           setOpenDialog(true);
  //         } else {
  //           console.log("Error in uploading some files");
  //         }
  //       } else {
  //         console.log("No files registered");
  //       }
  //     } else {
  //       console.log("No files selected for upload");
  //     }
  //   } catch (error) {
  //     console.log('Error registering files:', error);
  //   }
  // };
  const handleSaveClick = async () => {
    setIsSaveSuccessful(false); // Reset success state for new save attempt
    setShowSaveButton(true); // Ensure Save button is visible for new attempt
  
    try {
      // Filter selectedFiles to ensure only files linked to existing rows are uploaded
      const filteredSelectedFiles = selectedFiles.filter(file => rows.some(row => row.id === file.id));
  
      if (filteredSelectedFiles.length > 0) {
        const { storefileUploadResponse, storeFileNameArray } = await uploadFiles(filteredSelectedFiles);
  
        if (storefileUploadResponse?.length > 0) {
          let storefileUploadResponseFinal = [];
  
          for (let i = 0; i < storefileUploadResponse.length; i++) {
            const file = storefileUploadResponse[i];
         
            const documentTitle = storeFileNameArray.find((item) => item.id === file.fileName)?.filename;
            const documenttype = documentTitle.split('.').pop().toLowerCase();
  
            if (documentTitle) {
              const payload = {
                filename: file.fileName,
                filesize: file.fileSize,
                filepath: "D:/IFAC-X/UploadFolder",
                documenttitle: documentTitle,
                documenttype: documenttype,
                femtechnicaldrawingId: femtechnicaldrawingId,
              };
  
              try {
                const response = await saveFilesToAttachment(payload);
                setHasUnsavedChanges(false);
  
                if (response) {
                  storefileUploadResponseFinal.push(response);
                  fetchFiles(); // Fetch files to refresh display if needed
                } else {
                  console.log("Error saving file:", file.fileName);
                }
              } catch (error) {
                console.log("Error saving file:", error);
              }
            } else {
              console.log("Document Title not found for file:", file.fileName);
            }
          }
  
          if (storefileUploadResponseFinal.length === storefileUploadResponse.length) {
            setIsSaveSuccessful(true); // Mark as successful if all files saved
            //setShowSaveButton(false); // Hide Save button if successful
            setOpenDialog(true); // Open dialog on successful save
          } else {
            console.log("Error in uploading some files");
          }
        } else {
          console.log("No files registered");
        }
      } else {
        console.log("No files selected for upload");
      }
    } catch (error) {
      console.log("Error registering files:", error);
      setIsSaveSuccessful(false); // Set as unsuccessful on error
      setShowSaveButton(true); // Keep Save button visible to allow retry
    }
  };
  const handleCancel = () => {
    if (hasUnsavedChanges && !isView) {
      setCancelDialogOpen(true);
    } else {
      navigate(-1, { replace: true });
    }
  };

  const handleCancelDialogClose = () => {
    setCancelDialogOpen(false);
  };

  const handleCancelDialogConfirm = () => {
    setCancelDialogOpen(false);
    navigate(-1, { replace: true });
  };


  const handleSnackbarClose = () => {
    setError(false);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <DefaultCard sx={{ height: '100%' }}>
        <form style={{ position: 'relative' }}>
          <Stack>
            <Typography variant="labelSm" mt={0}>
              Please add files in format of doc, jpg, png, pdf, xlsx, csv and
              file size should be less than 20 MB.
            </Typography>
          </Stack>
          <Stack direction={"row"} justifyContent={"end"}>
            <Stack mb={1}>
              
             <Button 
  variant="contained" 
  onClick={handleAddRow} 
  disabled={isView} // This disables the button if isView is true
> 
  <AddRoundedIcon />
  Add File
</Button>

            </Stack>
          </Stack>
          <CustomAgGrid

            rows={rows}
            columns={[
              {
                field: 'file',
                headerName: 'File',
                flex: 1,
                cellRenderer: (params) => (
                  <Button variant="outlined" component="label" disabled={params.data?.documenttitle && isView} 
                  >
                    {params.data.documenttitle ? 'FILE UPLOADED' : 'BROWSE FILE'}
                   
                    <input
                      type="file"
                      hidden
                      onChange={(event) => handleFileChange(event, params?.data?.id)} 
                    />
                  </Button>
                ),
              },
              {
                field: 'documenttitle',
                headerName: 'File Name',
                flex: 1,
              },
              {
                field: 'documenttype',
                headerName: 'File Type',
                flex: 1,
              },
              {
                field: 'filesize',
                headerName: 'Size',
                flex: 1,
              },
              {
                field: 'actions',
                type: 'actions',
                headerName: 'Actions',
                flex: 1,
                cellClassName: 'actions',
                cellRenderer: (params) => (
                  <>
                    <Button onClick={handleDeleteClick(params?.data?.id)} disabled={isView}>
                      <DeleteIcon />
                    </Button>
                    <Button onClick={(event) => handleDownloadClick(event, params.data)} >
                      {params?.data?.id ? <DownloadIcon /> : <></>}
                    </Button>
                  </>
                ),
              },
            ]}
            setGridApi={setGridApi}
          />
        </form>
      </DefaultCard>
      {isView ? (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
          <Button variant="outlined" sx={{ m: 1 }} onClick={handleCancel}>
            Back
          </Button>
        </Box>

      ) : (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
        {/* Conditionally render the Save button */}
        {/* {!isSaveSuccessful && (
          <Button
            variant="contained"
            color="primary"
            sx={{ m: 1 }}
            onClick={handleSaveClick}
            disabled={isView}
          >
            Save
          </Button>
        )} */}
        {showSaveButton && (
      <Button
        variant="contained"
        color="primary"
        sx={{ m: 1 }}
        onClick={handleSaveClick}
        disabled={isView}
      >
        Save
      </Button>
    )}
        <Button variant="outlined" sx={{ m: 1 }} onClick={handleCancel}>
          Back
        </Button>
      </Box>
      )}

      <CustomDialog
        open={error}
        onClose={handleSnackbarClose}
        content={errorMessage}
        confirmBtn="OK"
        onConfirm={() => setError(false)}
      />
      <CustomDialog
        open={openDialog}
        onClose={handleCloseDialog}
        content="Files have been uploaded successfully."
        confirmBtn="OK"
        onConfirm={handleCloseDialog}
      />
      <CustomDialog
        open={cancelDialogOpen}
        onClose={handleCancelDialogClose}
        title="Unsaved Changes"
        content="Record(s) not Saved/Updated. Do you want to continue?"
        confirmBtn="Yes"
        cancelBtn="No"
        onConfirm={handleCancelDialogConfirm}
        onCancel={handleCancelDialogClose}
      />
      <CustomDialog
        open={deleteDialogOpen}
        onClose={handleDeleteDialogClose}
        title="Confirm Delete"
        content="Are you sure you want to delete?"
        confirmBtn="Yes"
        cancelBtn="No"
        onConfirm={handleDeleteConfirm}
        onCancel={handleDeleteDialogClose}
      />

      <CustomDialog
        open={successDialogOpen}
        onClose={handleSuccessDialogClose}
        content={successMessage}
        confirmBtn="OK"
        onConfirm={handleSuccessDialogClose}
      />
    </>
  );
}
